'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.li.withConfig({
  componentId: 'ekn81e-0'
})(['padding:2px 0 0;list-style-type:none;color:', ';'], function (p) {
  return p.theme.errorColor;
});